import React from "react";
import PropTypes from "prop-types";

const VideoSectionPlaylistSwitch = ({
  playlists,
  playlistIndex,
  setPlaylistIndex,
}) => {
  if (playlists.length <= 1) {
    return null;
  }

  const handleSelectChange = (e) => {
    const { value } = e.target;

    setPlaylistIndex(value);
  };

  return (
    <div className="video-section__switch">
      <button
        className="switch"
        type="button"
        onClick={() => {
          setPlaylistIndex(playlistIndex + 1);
        }}
        disabled={playlistIndex >= playlists.length - 1}
      >
        <svg className="switch__icon" width="11" height="11">
          <use xlinkHref="#arrow-left" width="11" height="11" />
        </svg>
      </button>
      <select
        className="select"
        value={playlistIndex}
        onChange={handleSelectChange}
      >
        {playlists.map((playlist, index) => (
          <option value={index} key={index}>
            {playlist.title}
          </option>
        ))}
      </select>
      <button
        className="switch"
        type="button"
        onClick={() => {
          setPlaylistIndex(playlistIndex - 1);
        }}
        disabled={playlistIndex <= 0}
      >
        <svg className="switch__icon" width="11" height="11">
          <use xlinkHref="#arrow-right" width="11" height="11" />
        </svg>
      </button>
    </div>
  );
};

VideoSectionPlaylistSwitch.propTypes = {
  playlists: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  playlistIndex: PropTypes.number.isRequired,
  setPlaylistIndex: PropTypes.func.isRequired,
};

export default VideoSectionPlaylistSwitch;
